import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationLayoutComponent } from '@volo/abp.ng.theme.lepton';
import { NotificationMainComponent } from './notification-main/notification-main.component';

const routes: Routes = [
  {
    path: '',
    component: ApplicationLayoutComponent,
    children: [
      {
        path: '',
        component: NotificationMainComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationRoutingModule {}
